module.exports = __webpack_public_path__ + "img/service14.ab82444a.svg";